<template>
    <table  border="1" align="center" cellpadding="10" cellspacing="5" class="lisd">
        <thead>
        <tr>
            <th colspan="3">用房需求</th>
            <th colspan="3">酒店报价</th>
        </tr>
        </thead>
        <thead>
        <tr>
            <th>日期</th>
            <th>房型</th>
            <th>间数</th>
            <th>房名</th>
            <th>单价</th>
            <th>早餐</th>
        </tr>
        </thead>
        <tbody v-for="(arrs,index) in priceArrs" :key="index">
            <tr>
              <td  :rowspan="offer_info(arrs.offer_info)">
                  {{arrs.date | formatTimestamp(2)}}
              </td>
              </tr>
              <tr v-for="item  in arrs.offer_info" :key="item.i">
              <td>
                  {{item.type | formatVar('roomStyle')}}
              </td>
              <td>{{item.room_num}} 间</td>
              <td>
                  {{item.offer_title}}
              </td>
              <td><span>{{item.offer_price}}元/晚/间</span></td>
              <td>{{item.breakfast||postInfo.breakfast_type }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import { mapState,mapGetters,mapActions } from 'vuex'
export default {
    props:{
        priceArrs:{
        type: Array,
          default () {
            return [
              {offer_info:[]}
            ]
          }
        },
        postInfo:'',
    },
    data() {
        return {
            
        }
    },
    computed: {
      ...mapState(['RoomMeetDetail']),
    },
    methods: {
        ...mapActions(['getRoomDetail','getMeetDetail','GetOrderDetail']), 
     //展示房型、会议室图片
     offer_info(i){
      if(i){
        return i.length+1
      }
     },
      async showRoomImgs(item,type) {
        if(item==0) return;
        let data = {
          type:3,
          id:item
        }
        switch (type) {
          case 'room':
            await this.getRoomDetail(data);
            break;
          case 'meet':
            await this.getMeetDetail(data);
            break;
        }
        if(this.RoomMeetDetail!=''){
          this._CarouselView({
            currentImg: 0,
            picArray: this.RoomMeetDetail.pic
          })
        }
      }
    },
}
</script>
<style scoped>
.lisd th, .lisd td{
    text-align: center;
}
.lisd td, .lisd th {
    padding: 4px 10px;
    font-size: 12px;
} 
</style>